import React from 'react';
import { SiteBrandedLoader, BrandSpinnerRing, type SiteBrandedLoaderTone } from './SiteBrandedLoader';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  /** true: تمام صفحه ثابت (پیش‌فرض)؛ false: بلوک وسط صفحه/کارت */
  fullScreen?: boolean;
  tone?: SiteBrandedLoaderTone;
}

/**
 * لود پرمصرف قبلی؛ همان ظاهر برند با لوگو و حلقه.
 */
const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  className = '',
  fullScreen = true,
  tone = 'light',
}) => (
  <SiteBrandedLoader
    variant={fullScreen ? 'fullscreen' : 'section'}
    size={size}
    tone={tone}
    className={className}
  />
);

export { BrandSpinnerRing };
export default LoadingSpinner;
